import { render } from "./PartnersByIndustryChart.vue?vue&type=template&id=ca2eaad6&scoped=true"
import script from "./PartnersByIndustryChart.vue?vue&type=script&lang=js"
export * from "./PartnersByIndustryChart.vue?vue&type=script&lang=js"

import "./PartnersByIndustryChart.vue?vue&type=style&index=0&id=ca2eaad6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ca2eaad6"

export default script